import React, { useEffect, useState } from 'react';

import { get, isEmpty } from 'lodash';
import { getColorCode } from '../../api/color';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import {
  digitalLiveClassRequest,
  liveClassPlayerRequest
} from '../../actions/digitalLiveClassActions';
import { openSnackBar } from '../../actions/snackbarAction';
// Global Components
import { dateFormat } from '../../api/dateFormat';
import NoData from '../../components/NoData';
import TimerCard from '../../components/TimerCard';
import LoadingSkeleton from '../../components/LoadingSkeleton';
// Styles
import './styles.scss';
import { Grid } from '@material-ui/core';
import PageHeading from '../../components/PageHeading';

export default function LiveClasses() {
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [isOpenFeedback, setIsOpenFeedback] = useState(false);

  // Reducers
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', {}));
  const profile = useSelector(state =>
    get(state, 'loginReducer.data.profile', '')
  );
  const errorMessage = useSelector(state =>
    get(state, 'digitalLiveClassReducer.errorMessage', '')
  );
  const digitalLiveClassListData = useSelector(state =>
    get(state, 'digitalLiveClassReducer.data', {})
  );

  const IsFeedbackAvailable = useSelector(state =>
    get(state, 'digitalLiveClassReducer.IsFeedbackAvailable', false)
  );
  const feedbackURL = useSelector(state =>
    get(state, 'digitalLiveClassReducer.feedbackURL', '')
  );

  //   Functions
  useEffect(() => {
    setIsFetching(true);
    digitalLiveClassRequest(jwt, profile.EmpCode ? true : false, dispatch).then(
      () => {
        setIsFetching(false);

        setIsOpenFeedback(true);
      }
    );    
  }, []);

  useEffect(() => {
    if (!profile.EmpCode && isOpenFeedback && IsFeedbackAvailable && feedbackURL !== null)
    {
      setIsOpenFeedback(false);

      try{
        window.open(feedbackURL, '_self', "height=500,width=1000");
      }
      catch (error) {
        console.log(error);
      }
    }
    
  }, [IsFeedbackAvailable, feedbackURL, isOpenFeedback]);

  
  const onRefresh = React.useCallback(() => {
    setIsFetching(true);
    digitalLiveClassRequest(jwt, profile.EmpCode ? true : false, dispatch).then(
      () => {
        populatedigitalClassList();
        setIsFetching(false);
      }
    );
  });

  const conv2Arr = () => {
    let result = [];
    let unique = [...new Set(digitalLiveClassListData.map(a => a.ClassDate))];
    unique.map((data, i) => {
      result.push({
        ClassDate: unique[i],
        listClass: digitalLiveClassListData.filter(date => {
          return date.ClassDate.includes(unique[i]);
        })
      });
    });

    return result;
  };
  // Functions
  const populatedigitalClassList = () => {
    const newClassArray = conv2Arr();
    const list = [];
    (profile.EmpCode ? newClassArray : digitalLiveClassListData).map(
      (data, index) => {
        let classList = [];
        data.listClass.map((classData, classIndex) => {
          let uniqueCode = `${index}${classIndex}`;
          return classList.push(
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={classData.RemainingTime}
              className="flex"
            >
              <TimerCard
                index={uniqueCode}
                key={uniqueCode}
                subject={classData.SubjectName}
                dateTime={`${classData.ClassStart} - ${classData.ClassEnd}`}
                topic={classData.ModuleNo}
                callback={onRefresh}
                bottomColor={getColorCode(
                  get(classData, 'ClassCode', '').replace('bg-', '')
                )}
                handler={() => {
                  if (classData.RemainingTime < 0) {
                    fetchLiveURL(classData.UniqueCode);
                  } else {
                    dispatch(
                      openSnackBar({
                        message: 'This live class is yet to start, please wait',
                        severity: 'warning'
                      })
                    );
                  }
                }}
                start={classData.RemainingTime < 0 ? 'EXPIRE IN' : 'START IN'}
                initialTime={
                  classData.RemainingTime < 0
                    ? classData.Expiry * 1000
                    : classData.RemainingTime * 1000
                }
              />
            </Grid>
          );
        });
        return list.push(
          <div className="class-wrapper" key={index}>
            <div className="date-heading">
              {profile.EmpCode
                ? dateFormat(data.ClassDate)
                : `${data.ClassDay}, ${dateFormat(data.ClassDate)}`}
            </div>
            <Grid container spacing={2} key={index}>
              {classList}
            </Grid>
          </div>
        );
      }
    );
    return list;
  };

  const fetchLiveURL = async uniqueCode => {
    try {
      //   setIsFetching(true);
      liveClassPlayerRequest(
        jwt,
        profile.EmpCode ? true : false,
        uniqueCode,
        dispatch
      ).then(res => {
        window.open(res.data.ClassURL);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <PageHeading titlePrimary="Digital Live" titleSecondary="Classes" />
      {isFetching ? (
        <LoadingSkeleton type="bigcardlist" />
      ) : digitalLiveClassListData != null &&
        digitalLiveClassListData.length ? (
        <>{populatedigitalClassList()}</>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </>
  );
}
